export function convertInEuro(x) {
  if (x > 0) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").concat(" €");
  } else {
    return 0 + " €";
  }
}